export const STREAM_ENDPOINT = 'https://stream-api-dot-rising-higher-dev.uc.r.appspot.com';
